/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".titleField_3d1133dd{display:inline-block}\n"}]);
export const titleField = "titleField_3d1133dd";